import React, { Component } from "react";
import Data from "../../config/data";
import ScrollView from "./ScrollView";
import Content from "./Content";

export default class YnPrivacy extends Component {

    render() {
        const data = Data.ynPrivacy;
        return (
            <ScrollView>
                <Content data={data} />
            </ScrollView>
        );
    }

}


// WEBPACK FOOTER //
// ./src/component/ynPrivacy/ynPrivacy.js